import { EDIT_USER, EDIT_PUBLISHER } from '../action-types';

const initialState = {
  user: null,
  publisher: null,
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_USER:
      return { ...state, user: action.user };
    case EDIT_PUBLISHER:
      return { ...state, publisher: action.publisher };
    default:
      return { ...state };
  }
};

export default user;
